import React from 'react';
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer";
// 2026-05-14 — Embedded PLG demo widget. The previous merge to `dev`
// dropped the DemoChat files; re-importing here so the next push
// puts the chatbot live on equidei.com/solution/factories.
import DemoChat from "../components/DemoChat/DemoChat.jsx";

const Factories = () => {
  return (
    <div
      style={{ fontFamily: "'Inter', sans-serif", backgroundColor: '#0d1117', color: '#e2e8f0' }}
      className="overflow-x-hidden"
    >
      <Navbar page="solution" />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="100%" height="100%" fill="url(#pattern0)" />
            <defs>
              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="0.1" height="0.1">
                <path
                  d="M0.05 0.05H0.1V0H0.05V0.05ZM0.05 0.05V0.1H0V0.05H0.05ZM0.05 0.05H0V0.05H0.05Z"
                  fill="#a78bfa"
                  opacity="0.1"
                />
              </pattern>
            </defs>
          </svg>
        </div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 animate-fade-in">
            The Future of Your Factory's Legacy. <br className="hidden md:inline" />
            Built Together.
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 mb-10 max-w-3xl mx-auto animate-fade-in-delay-1">
            Axia and Kaya – the AI sisters empowering Ludhiana's next-gen factory leaders to achieve unprecedented growth with unwavering trust and seamless transformation.
          </p>
          <a
            href="https://msme.equidei.com/"
            className="inline-block px-8 py-4 rounded-full text-lg font-semibold btn-gradient hover:scale-105 animate-fade-in-delay-2"
          >
            Start Your Free Trial
          </a>
        </div>
      </section>

      {/* PLG demo widget — 5 free messages, no card. 2026-05-15 */}
      <section className="py-16 px-3 sm:px-4 lg:px-6 bg-gradient-to-b from-black via-[#0a0612] to-gray-900 relative overflow-hidden">
        {/* Brand glow halo behind the section so the chat feels
            powerful, not dull. */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-40"
          style={{
            background:
              "radial-gradient(circle at 50% 30%, rgba(165,48,208,0.25), transparent 55%)",
          }}
        />
        <div className="container mx-auto max-w-5xl relative z-10">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-5xl font-extrabold text-white mb-3 tracking-tight">
              Try Axia <span className="bg-gradient-to-r from-fuchsia-400 to-indigo-400 bg-clip-text text-transparent">right now</span>
            </h2>
            <p className="text-base text-gray-300/90">
              5 free messages · phone OTP or Google sign-in · No credit card
            </p>
          </div>
          <DemoChat />
        </div>
      </section>

      {/* The Dilemma Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold section-header mb-8">
            The Modern Leader's Dilemma
          </h2>
          <p className="text-lg text-gray-300 max-w-4xl mx-auto mb-12">
            You stand at a crossroads—committed to honoring the legacy your family built, yet driven to innovate with modern technology. How do you embrace the data-driven future of manufacturing without disrupting the trusted team and systems that are the heart of your business?
          </p>
          <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto">
            <div className="bg-gray-800 p-8 rounded-lg shadow-xl border border-purple-700">
              <h3 className="text-2xl font-semibold text-purple-300 mb-4">Embracing Innovation</h3>
              <p className="text-gray-400">The need for cutting-edge technology, AI, and data analytics to optimize operations, improve efficiency, and stay competitive in a rapidly evolving market.</p>
            </div>
            <div className="bg-gray-800 p-8 rounded-lg shadow-xl border border-purple-700">
              <h3 className="text-2xl font-semibold text-purple-300 mb-4">Preserving Legacy</h3>
              <p className="text-gray-400">The desire to maintain the core values, culture, and most importantly, the experienced workforce that have been the backbone of your family's success for generations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Axia & Kaya Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-800">
        <div className="container mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center section-header mb-12">
            Our Solution: The Super heroes of EquiDEI
          </h2>
          <p className="text-lg text-gray-300 text-center max-w-3xl mx-auto mb-12">
            We believe you shouldn't have to choose. Our platform was born from a single vision delivered by two powerful, specialized AIs working in perfect harmony.
          </p>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            {/* Axia Card */}
            <div className="bg-gray-900 p-8 rounded-lg shadow-2xl border border-purple-600 transform hover:scale-105 transition duration-300">
              <div className="flex items-center space-x-6 mb-6">
                <img src="/img/illustrations/Axia.png" alt="Axia Avatar" className="w-24 h-24 rounded-full shadow-lg" />
                <h3 className="text-3xl font-bold text-purple-400">AXIA: The Architect of Prosperity</h3>
              </div>
              <p className="text-gray-300 mb-6 text-lg">
                Axia is your master strategist, bringing logic and intelligence to every operation.
              </p>
              <ul className="list-disc list-inside text-gray-400 space-y-2">
                <li><strong>Unlocks hidden production capacity</strong> with precise data.</li>
                <li><strong>Delivers data integrity</strong> for unmatched investment readiness.</li>
                <li><strong>Builds a secure, efficient operational blueprint</strong> for growth.</li>
                <li><strong>Secures the future of your business</strong> with powerful analytics.</li>
              </ul>
            </div>

            {/* Kaya Card */}
            <div className="bg-gray-900 p-8 rounded-lg shadow-2xl border border-blue-600 transform hover:scale-105 transition duration-300">
              <div className="flex items-center space-x-6 mb-6">
              <img src="/img/illustrations/Kaya.png" alt="Kaya Avatar" className="w-24 h-24 rounded-full shadow-lg" />
                <h3 className="text-3xl font-bold text-blue-400">KAYA: The Guardian of Integrity</h3>
              </div>
              <p className="text-gray-300 mb-6 text-lg">
                Kaya is the compassionate heart, ensuring your people thrive through trust and transparency.
              </p>
              <ul className="list-disc list-inside text-gray-400 space-y-2">
                <li><strong>Engages your team</strong> in their local language, building connection.</li>
                <li><strong>Promotes honesty</strong> with fair, transparent tracking and incentives.</li>
                <li><strong>Empowers workers</strong> with performance-linked insights and rewards.</li>
                <li><strong>Ensures a smooth, inclusive adoption</strong> of new processes.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 3-Step Transformation */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold section-header mb-12">
            Your Transformation in 3 Steps: A Journey with Axia & Kaya
          </h2>
          <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
            {[
              {
                step: 1,
                color: 'purple-400',
                title: 'Axia Analyzes & Architects Your Blueprint',
                desc: 'We connect Axia to your operations, allowing her powerful AI to instantly process your entire system. You gain an immediate, clear view of your factory’s true potential, identifying areas for growth and efficiency.'
              },
              {
                step: 2,
                color: 'blue-400',
                title: 'Kaya Connects & Empowers Your Team',
                desc: 'We introduce Kaya to your team on WhatsApp. She seamlessly integrates into their daily workflow, providing simple, encouraging communication that makes every team member feel valued, understood, and part of the mission.'
              },
              {
                step: 3,
                color: 'green-400',
                title: 'Your Business Thrives: Growth & Legacy United',
                desc: "With Axia providing the strategic vision and Kaya ensuring human-centric adoption, your factory transforms. You achieve powerful growth, secure your family's legacy, and build a more equitable future for everyone."
              },
            ].map(({ step, color, title, desc }) => (
              <div
                key={step}
                className={`bg-gray-800 p-8 rounded-lg shadow-xl border border-gray-700 flex flex-col items-center text-center transition duration-300`}
              >
                <div className={`text-5xl font-bold text-${color} mb-4`}>{step}</div>
                <h3 className="text-2xl font-semibold text-white mb-4">{title}</h3>
                <p className="text-gray-400">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section id="demo" className="bg-gradient-to-r from-purple-800 to-blue-800 py-16 px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="container mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Ready to Unlock Your Factory's Full Potential?
          </h2>
          <p className="text-xl mb-10 max-w-3xl mx-auto">
            Discover how Axia and Kaya can transform your operations, empower your workforce, and secure your family's legacy.
          </p>
          <a
            href="https://msme.equidei.com/"
            className="inline-block px-10 py-4 rounded-full text-lg font-semibold bg-white text-purple-800 shadow-lg hover:bg-gray-200 hover:scale-105 transition duration-300"
          >
            Start Your Free Trial Today
          </a>
        </div>
      </section>

      <Footer page="solution" />
    </div>
  );
};

export default Factories;
